// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogLayout_root__1PEYF","main":"BlogLayout_main__1AC4b"};